import React, { useMemo, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { HomeValuationForm } from '../components/sections/HomeValuationForm';
import { PrivacyPolicyModal } from '../components/modals/PrivacyPolicyModal';
import { CustomAreaContent, AreaValuationCTA } from '../components/sections/CustomAreaContent';
import { SellerHeader, SellerHero } from '../components/seller/SellerHero';
import { SellingInCopy, SellerTestimonials, SellerFaqSection, MoreSellerGuides, SellerFooter, SellerStickyBar } from '../components/seller/SellerSections';
import { useSeo } from '../hooks/useSeo';
import { sellerSeoMeta, buildSellerJsonLd } from '../utils/sellerSeo';
import { DEFAULT_SELLER_AREA, SELLER_AREAS, findSellerArea, sellerFaqs } from '../constants/sellerAreas';

export default function SellerLandingPage() {
  const { slug } = useParams();
  const area = slug ? findSellerArea(slug) : DEFAULT_SELLER_AREA;
  const [showPrivacy, setShowPrivacy] = useState(false);
  const faqs = useMemo(() => (area ? sellerFaqs(area) : []), [area]);
  const seo = useMemo(() => sellerSeoMeta(area, slug), [area, slug]);
  const jsonLd = useMemo(() => (area ? buildSellerJsonLd(area, faqs, seo) : null), [area, faqs, seo]);
  const otherAreas = useMemo(() => (area ? SELLER_AREAS.filter((a) => a.slug !== area.slug) : []), [area]);
  useSeo({ ...seo, jsonLd });

  if (!area) return <Navigate to="/home-value" replace />;
  const openPrivacy = () => setShowPrivacy(true);

  return (
    <div className="min-h-screen bg-ivory text-neutral-800" data-testid="seller-landing-page">
      <SellerHeader />
      <SellerHero area={area} />

      <section id="home-value-form" className="-mt-8 relative z-10 max-w-6xl mx-auto px-5 grid lg:grid-cols-[1fr_1.1fr] gap-10 items-start pb-20">
        <SellingInCopy area={area} />
        <HomeValuationForm openPrivacyPolicy={openPrivacy} />
      </section>

      {area.custom && <CustomAreaContent area={area} />}
      {area.custom?.cta && <AreaValuationCTA cta={area.custom.cta} openPrivacyPolicy={openPrivacy} />}

      <SellerTestimonials />
      <SellerFaqSection areaName={area.name} faqs={faqs} />
      <MoreSellerGuides areas={otherAreas} />
      <SellerFooter />
      <SellerStickyBar />

      <PrivacyPolicyModal open={showPrivacy} onClose={() => setShowPrivacy(false)} />
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}
